export const findCurrectPermission = (permissionsName) => {
  // const auth = useAuth();
  // auth.getUserRights();
  const permissionsObj = localStorage.getItem("userPermissions");
  const permissions = permissionsObj ? JSON.parse(permissionsObj) : [];
  if (permissionsName && permissions?.length)
    return permissions.find((role) => role.uniqueCode === permissionsName)
      ?.isAccess;
  else {
  }
};
